module.exports = __webpack_public_path__ + "img/1F1E7-1F1FF.a398bc5f.svg";